// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import store from './store'
import './assets/js/dialog'

import './permission.js' // permission control



import XrAvatar from '@/components/XrAvatar'
import XrButton from './components/XrButton/index'
import XrIcon from './components/XrIcon/index'
import XrLayout from './components/XrLayout/index'
import XrPageSelect from './components/XrPageSelect/index'
import XrCollapse from './components/XrCollapse/index'
import XrUploadSinglePicture from './components/XrUploadSinglePicture/index'
import XrUploadImg from './components/XrUploadImg/index'
import XrTable from './components/XrTable/index'
import XrDataTable from './components/XrTable/dataTable'
import PageSelectDialog from './components/PageSelect/pageSelectDialog'
import XrUpload from './components/XrUpload/index'
import XrResource from './components/XrResource/index'
import XrResourceDialog from './components/XrResource/file-dialog'
import XrResourceImgDialog from './components/XrResource/img-dialog'
import XrMultipleSelect from './components/XrMultipleSelect/index'
import XrSelect from './components/XrSelect/index'
import XrTableSelect from './components/XrTable/table-select'
import XrTableSelectSpecial from './components/XrTable/table-select-special'
import XrFileView from './components/XrFileView/index'
import XrInputFile from './components/XrInputFile/index'
import XrTagAdd from './components/XrTagAdd/index'
import XrCheckbox from './components/XrCheckbox/index'
import XrMultiParamAdd from './components/XrMultiParamAdd/index'
import XrMultiStrAdd from './components/XrMultiStrAdd/index'
import XrLoading from './components/XrLoading/index'
import XrEditor from "./components/XrEditor";
import XrFormSingleFile from "./components/XrFormSingleFile";
import XrInputNumberRange from "./components/XrInputNumberRange";
import ArchiveSelectDialog from './views/ph/common/archive-select-dialog'

Vue.component('xr-avatar', XrAvatar)
Vue.component('xr-button', XrButton)
Vue.component('xr-icon', XrIcon)
Vue.component('xr-layout', XrLayout)
Vue.component('xr-page-select', XrPageSelect)
Vue.component('xr-collapse', XrCollapse)
Vue.component('xr-upload-single-picture', XrUploadSinglePicture)
Vue.component('xr-upload-img',XrUploadImg)
Vue.component('xr-table', XrTable)
Vue.component('xr-data-table', XrDataTable)
Vue.component('page-select-dialog', PageSelectDialog)
Vue.component('xr-upload', XrUpload)
Vue.component('xr-form-single-file', XrFormSingleFile)
Vue.component('xr-resource', XrResource)
Vue.component('xr-resource-dialog', XrResourceDialog)
Vue.component('xr-resource-img-dialog', XrResourceImgDialog)
Vue.component('xr-multiple-select', XrMultipleSelect)
Vue.component('xr-select', XrSelect)
Vue.component('xr-table-select', XrTableSelect)
Vue.component('xr-table-select-special', XrTableSelectSpecial)
Vue.component('xr-file-view', XrFileView)
Vue.component('xr-input-file', XrInputFile)
Vue.component('xr-tag-add', XrTagAdd)
Vue.component('xr-checkbox', XrCheckbox)
Vue.component('xr-multi-param-add', XrMultiParamAdd)
Vue.component('xr-multi-str-add', XrMultiStrAdd)
Vue.component('xr-loading', XrLoading)
Vue.component('XrEditor', XrEditor)
Vue.component('xr-input-number-range', XrInputNumberRange)
Vue.component('archive-select-dialog', ArchiveSelectDialog)


// openWebOfficeEdit


import request from './utils/request'

Vue.prototype.request = request

//recombinationMap
import CommonUtils from './utils/xhh/common'
Vue.prototype.CommonUtils = CommonUtils

// import 'normalize.css/normalize.css' // A modern alternative to CSS resets

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);
import Vant from 'vant';
import 'vant/lib/index.css';
Vue.use(Vant);
import router from './router'

/**挂载防止重复点击事件*/
import preventReClick from './utils/xhh/preventReClick'
Vue.use(preventReClick);


// 定义全局过滤器：根据 value 在 list 中查找对应的 label
// 参数说明：
// value: 当前需要转换的值 (如: 1, 'A')
// list: 包含 { value, label } 对象的数组
// keyName: (可选) 列表中代表值的字段名，默认为 'value'
// labelName: (可选) 列表中代表显示文本的字段名，默认为 'label'
Vue.filter('dictFilter', function (value, list, keyName = 'value', labelName = 'label') {
  // 1. 边界检查：如果值为空或列表不存在，直接返回原值或空
  if (value === null || value === undefined || !list || !Array.isArray(list)) {
    return value
  }

  // 2. 在列表中查找匹配项
  // 注意：这里使用 == 以兼容字符串和数字类型的匹配 (如 '1' == 1)
  const item = list.find(item => item[keyName] == value)

  // 3. 返回找到的 label，如果没找到则返回原值或默认提示
  return item ? item[labelName] : value
})

/**挂载回车键跳转下一个输入框指令*/
import EnterNext from './directives/enter-next'
Vue.directive('enter-next', EnterNext);

import './styles/index.scss';
import './assets/css/common.scss';

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js